import { theme } from '@app/styles/theme'
import { css } from '@emotion/react'

export const formRoot = css`
  width: 100%;
`

export const formStack = css`
  gap: 20px;
`

export const emptyStateWrap = css`
  margin-bottom: 4px;
`

export const fieldsSection = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  border: 1px solid ${theme.palette.neutral.light};
  border-radius: 12px;
  background: ${theme.palette.background.paper};
`

export const topFieldsGrid = css`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

export const fieldControl = css`
  .MuiInputLabel-root {
    font-weight: 500;
  }

  .MuiOutlinedInput-root {
    background: ${theme.palette.background.default};
    border-radius: 10px;
  }
`

export const modeSection = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const modeToggleGroup = css`
  align-self: flex-start;
  border-radius: 10px;
  overflow: hidden;
  background: ${theme.palette.background.default};

  .MuiToggleButton-root {
    padding: 8px 14px;
    border-color: ${theme.palette.neutral.light};
    color: ${theme.palette.text.secondary};
    text-transform: none;
    font-weight: 500;
  }

  .MuiToggleButton-root.Mui-selected {
    background: ${theme.palette.primary.main};
    color: ${theme.palette.primary.contrastText};
  }

  .MuiToggleButton-root.Mui-selected:hover {
    background: ${theme.palette.primary.dark};
  }
`

export const statementField = css`
  .MuiInputLabel-root {
    font-weight: 500;
  }

  .MuiOutlinedInput-root {
    align-items: flex-start;
    padding: 0;
    border-radius: 12px;
    background: ${theme.palette.background.default};
  }

  .MuiOutlinedInput-inputMultiline {
    padding: 16px;
    font-size: 0.95rem;
    line-height: 1.6;
  }
`

export const previewPanel = css`
  min-height: 180px;
  padding: 16px;
  border: 1px solid ${theme.palette.neutral.light};
  border-radius: 12px;
  background: ${theme.palette.background.default};
  color: ${theme.palette.text.primary};
  font-size: 0.95rem;
  line-height: 1.7;

  h1,
  h2,
  h3,
  h4 {
    margin-top: 1.25em;
    margin-bottom: 0.5em;
    color: ${theme.palette.text.primary};
    font-weight: 600;
    line-height: 1.3;
  }

  h1 {
    font-size: 1.2rem;
  }

  h2 {
    font-size: 1.05rem;
  }

  h3,
  h4 {
    font-size: 1rem;
  }

  p {
    margin-top: 0;
    margin-bottom: 0.9em;
    color: ${theme.palette.text.primary};
  }

  ul,
  ol {
    padding-left: 1.25rem;
    margin-top: 0.25rem;
    margin-bottom: 1rem;
  }

  li {
    margin-bottom: 0.35rem;
  }

  strong {
    color: ${theme.palette.secondary.main};
  }

  code {
    padding: 0.12rem 0.35rem;
    border-radius: 6px;
    background: ${theme.palette.action.hover};
    font-size: 0.875em;
  }

  hr {
    border: 0;
    border-top: 1px solid ${theme.palette.neutral.light};
    margin: 1rem 0;
  }

  blockquote {
    margin: 1rem 0;
    padding-left: 12px;
    border-left: 3px solid ${theme.palette.primary.main};
    color: ${theme.palette.text.secondary};
  }

  a {
    color: ${theme.palette.primary.main};
  }
`

export const previewEmptyState = css`
  color: ${theme.palette.text.disabled};
`

export const actionsRow = css`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  padding-top: 4px;
`

export const submitButton = css`
  min-width: 168px;
  padding: 10px 16px;
  border-radius: 10px;
  text-transform: none;
  font-weight: 600;
  box-shadow: none;

  &:hover {
    box-shadow: none;
  }

  &:disabled {
    background: ${theme.palette.action.disabledBackground};
    color: ${theme.palette.action.disabled};
  }
`

export const formWrapper = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(3)};
`

export const sectionLabel = css`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: ${theme.palette.text.secondary};
  margin-bottom: ${theme.spacing(1)};
`

export const gradeSelect = css`
  .MuiOutlinedInput-root {
    /* background: ${theme.palette.background.paper}; */
  }
`

export const markdownEditorWrapper = css`
  border: 1px solid ${theme.palette.neutral.light};
  border-radius: ${theme.shape.borderRadius}px;
  overflow: hidden;

  &:focus-within {
    border-color: ${theme.palette.primary.main};
    box-shadow: 0 0 0 2px ${theme.palette.primary.main}22;
  }
`

export const toggleGroup = css`
  border-bottom: 1px solid ${theme.palette.neutral.light};
  border-radius: 0;
  padding: ${theme.spacing(0.5)} ${theme.spacing(0.5)};
  background: ${theme.palette.grey[50]};

  .MuiToggleButton-root {
    border: none;
    border-radius: ${theme.shape.borderRadius}px !important;
    font-size: 12px;
    font-weight: 500;
    padding: ${theme.spacing(0.4)} ${theme.spacing(1.5)};
    color: ${theme.palette.text.secondary};
    text-transform: none;
    letter-spacing: 0;

    &.Mui-selected {
      background: ${theme.palette.background.paper};
      color: ${theme.palette.text.primary};
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
    }
  }
`

export const markdownTextarea = css`
  .MuiOutlinedInput-root {
    border-radius: 0;
    border: none;
    background: ${theme.palette.background.paper};

    fieldset {
      border: none;
    }

    &:hover fieldset,
    &.Mui-focused fieldset {
      border: none;
    }
  }

  textarea {
    font-family: 'JetBrains Mono', 'Fira Code', monospace;
    font-size: 13px;
    line-height: 1.6;
    resize: vertical;
  }
`

export const previewBox = css`
  min-height: 150px;
  padding: ${theme.spacing(2)};
  background: ${theme.palette.background.paper};
  font-size: 14px;
  line-height: 1.7;

  h2 {
    font-size: 15px;
    font-weight: 500;
    margin-top: ${theme.spacing(2)};
    margin-bottom: ${theme.spacing(0.5)};
  }

  p {
    margin-top: 0;
    margin-bottom: ${theme.spacing(1)};
    color: ${theme.palette.text.secondary};
  }

  hr {
    border-color: ${theme.palette.neutral.light};
    margin: ${theme.spacing(2)} 0;
  }
`

export const submitRow = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: ${theme.spacing(1)};
  border-top: 1px solid ${theme.palette.neutral.light};
`
